import { render, staticRenderFns } from "./AssignClerksModal.vue?vue&type=template&id=6e0af69f&scoped=true"
import script from "./AssignClerksModal.vue?vue&type=script&lang=js"
export * from "./AssignClerksModal.vue?vue&type=script&lang=js"
import style0 from "./AssignClerksModal.vue?vue&type=style&index=0&id=6e0af69f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0af69f",
  null
  
)

export default component.exports